import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AuthSignIn } from '@uturn/portal/modules/auth/pages/sign-in';
import z from 'zod';

export const LoginSearchSchema = z.object({
	email: z.string().optional(),
	redirect: z.string().optional(),
});

export const Route = createFileRoute('/_auth/sign-in')({
	validateSearch: zodValidator(LoginSearchSchema),
	beforeLoad: ({ context }) => {
		if (!context.auth.isLoaded) {
			return;
		}
		if (context.auth.isAuthenticated) {
			throw redirect({ to: '/shipments' });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <AuthSignIn />;
}
